import { DraftsSlice } from "./reducer"

export const getOpenDraftsState = (state: { drafts: DraftsSlice }) => state.drafts
